var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContractorIconHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-3 {\n        fill: none;\n        stroke: #21505c;\n        stroke-linecap: round;\n        stroke-width: 1.1px;\n      }\n\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: #1797b1;\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flexible_hours") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.84,47.22A19.61,19.61,0,1,0,20.54,14.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.08 37.98 20.06 22.89 10.39 29.98 23.5 45.64 23.36 41.64 28.23 42.05 28.72 37.67 32.08 37.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.68,50.9,23.5,46,6.39,25.72c-1-1.26.33-4.09,2.86-6.22s5.56-3,6.61-1.75L33,38.06Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "23.5 46.03 23.84 41.78 28.23 42.05 28.72 37.67 32.97 38.06"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.81,
    y1: 22.43,
    x2: 10.34,
    y2: 30.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.79,
    y1: 46.68,
    x2: 31.85,
    y2: 49.15
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.35,
    y1: 28.72,
    x2: 34.35,
    y2: 15.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.35,
    y1: 28.72,
    x2: 43.64,
    y2: 25.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractorIconHours);
export default __webpack_public_path__ + "static/media/contractor-icon-hours.40f9957a049972de681994cb6ac41fcf.svg";
export { ForwardRef as ReactComponent };